module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_16-d9eb6d2ce77882080bf028cf6d2d1ea3.png";